import { render } from "./AttributeInput.vue?vue&type=template&id=78196944&scoped=true&ts=true"
import script from "./AttributeInput.vue?vue&type=script&lang=ts"
export * from "./AttributeInput.vue?vue&type=script&lang=ts"

import "./AttributeInput.vue?vue&type=style&index=0&id=78196944&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78196944"]])

export default __exports__